export default "__VITE_ASSET__wwnh5H5Oa6xT$bsq1SEbBQ__"